import {
  Box,
  Grid,
  Paper,
  Snackbar,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TablePagination,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import styles from "../../../styles.module.css";
import { useDispatch, useSelector } from "react-redux";
// import { editDeleteCharges, getChargesList } from "../../../../../actions/actions";
import CustomPagination from "../../reusableComponent/CustomPagination";
import {
  ActionMsg,
  AddButton,
  Breadcrumb,
  CustomePopover,
  DateConversionOnEntryPage,
  DeleteDialog,
  ExcelDownload,
  HandleCloseSnackbar,
  HandleSort,
  SearchInput,
  StyledTableCell,
  StyledTableRow,
  useMessageHandler,
} from "../../reusableComponent/Reusables";
import { rows } from "./../MastersFakeDb";
import {
  editDeleteCylinderHoldingLimit,
  getCylinderHoldingLimitList,
} from "../../../actions/actions";
const CylHoldingLimitList = () => {
  const dispatch = useDispatch();
  const login_details = sessionStorage.getItem('loginUser');
  const userD = JSON.parse(login_details);
  const userInfo = userD.userInfo;

  const [isDelete, setIsDelete] = useState(false);
  const [deleteInfo, setDeleteInfo] = useState();
  const [sortBy, setSortBy] = useState(null);

  const rows = useSelector(
    (state) => state.cly_holding_limit.cly_holding_limit
  );

  const [searchKey, setSearchKey] = useState("");

  const fields = ["id", "cust_name", "prod_code", "max_holding"];
  const labels = ["Id", "cust_name", "prod_code", "max_holding"];

  const [successMessage, setSuccessMessage] = useState(null);
  //const respMsgState = "test";
   const respMsgState = useSelector((state) => state.cly_holding_limit.message);
  const [total_count,setTotalCount]=useState(null)
  useEffect(() => {
    setTotalCount(rows[0]?.totalCount);
  }, [rows]);
  const [controller, setController] = useState({
    page: 0,
    rowsPerPage: 10,
  });

  const handleChangePage = (event, newPage) => {
    setController({
      ...controller,
      page: newPage,
    });
  };

  const handleChangeRowsPerPage = (event) => {
    setController({
      ...controller,
      rowsPerPage: parseInt(event.target.value, 10),
      page: 0,
    });
  };

  const fetchData = () => {
    const params = {
      page: controller.page,
      size: controller.rowsPerPage,
      searchKey: searchKey,
    };
    dispatch(getCylinderHoldingLimitList(params));
  };

  const handleSearch = (e) => {
    setSearchKey(e.target.value);
    const params = {
      page: controller.page,
      size:
        e.target.value === ""
          ? controller.rowsPerPage
          : rows[0]?.total_count || 0,
      searchKey: e.target.value,
    };
    dispatch(getCylinderHoldingLimitList(params));
  };

  useEffect(() => {
    fetchData();
  }, [controller]);

  // useEffect(() => {
  //   fetchData();
  // }, [controller.page, controller.rowsPerPage]);

  // const { shouldShowMsg, responseMessage } = useMessageHandler(
  //   null,
  //   setSuccessMessage,
  //   respMsgState
  // );

  // useEffect(() => {}, [shouldShowMsg, responseMessage]);

  const deleteRecord = (id) => {
    dispatch(
      editDeleteCylinderHoldingLimit({
        chl_id: id,
        changedUpdatedValue: "delete",
      })
    );
    setIsDelete(false);
    fetchData();
  };

  const handleDelete = (functions) => {
    setIsDelete(true);
    setDeleteInfo(functions);
  };

  const handleClose = (event, reason) => {
    setIsDelete(false);
    setDeleteInfo(null);
  };

  const { shouldShowMsg, responseMessage } = useMessageHandler(fetchData,null, setSuccessMessage, respMsgState);
       useEffect(() => {
              if (respMsgState) {
                  setSuccessMessage(respMsgState);
              }
          }, [respMsgState]);
      useEffect(() => {
      }, [shouldShowMsg, responseMessage,]);

  return (
    <>
      <Paper className={`${styles.cts_page}`}>
        <Breadcrumb
          routeSegments={[
            // { name: 'Dashbord', path: '/dashboard' },
            { name: "Cylinder Holding Limit Setting List" },
          ]}
        />
        <Box sx={{ display: "flex" }}>
          <Grid container spacing={2} sx={{ pt: 1.5, pb: 1.5 }}>
            <Grid item md={7} sm={6} xs={12}>
              <Box sx={{ display: "flex" }}>
                <Typography className={`${styles.form_title}`}>
                  Cylinder Holding Limit Setting
                </Typography>
              </Box>
            </Grid>
            <Grid
              item
              md={5}
              sm={6}
              xs={12}
              sx={{ display: "flex", justifyContent: "space-between" }}
            >
              <Box className={`${styles.excel_box}`}>
                <ExcelDownload
                  data={rows}
                  fields={fields}
                  labels={labels}
                  filename="Cylinder Holding Limit Setting List"
                />
              </Box>
              <SearchInput value={searchKey} onChange={handleSearch} />
              <AddButton to="/masters/add-cylinder-holding-limit" label="" />
            </Grid>
          </Grid>
        </Box>
        <TableContainer
          component={Paper}
          className={`${styles.list_tbl_container}`}
        >
          <Table size="small" stickyHeader>
            <TableHead>
              <StyledTableRow>
                <StyledTableCell
                  align="center"
                  className={`${styles.table_head}`}
                >
                  Action
                </StyledTableCell>
                <StyledTableCell
                  align="center"
                  className={`${styles.table_head}`}
                  onClick={() =>
                    HandleSort("cust_name", sortBy, setSortBy, rows)
                  }
                >
                  Customer Name
                  <span className={`${styles.sort_icon}`}>
                    {" "}
                    {sortBy === "cust_name" ? "▲" : "▼"}{" "}
                  </span>
                </StyledTableCell>
                <StyledTableCell
                  align="center"
                  className={`${styles.table_head}`}
                  onClick={() =>
                    HandleSort("prod_code", sortBy, setSortBy, rows)
                  }
                >
                  Product Code
                  <span className={`${styles.sort_icon}`}>
                    {" "}
                    {sortBy === "prod_code" ? "▲" : "▼"}{" "}
                  </span>
                </StyledTableCell>
                <StyledTableCell
                  align="right"
                  className={`${styles.table_head}`}
                  onClick={() =>
                    HandleSort("max_holding", sortBy, setSortBy, rows)
                  }
                >
                  Maximum Holding
                  <span className={`${styles.sort_icon}`}>
                    {" "}
                    {sortBy === "max_holding" ? "▲" : "▼"}{" "}
                  </span>
                </StyledTableCell>
              </StyledTableRow>
            </TableHead>
            <TableBody>
              {Array.isArray(rows) &&
                rows.map((row, index) => (
                  <StyledTableRow
                    key={row.name}
                    sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                  >
                    <StyledTableCell align="center">
                      <CustomePopover
                        row={row}
                        handleDelete={false}
                        linkTo="/masters/add-cylinder-holding-limit"
                      />
                    </StyledTableCell>
                    <StyledTableCell
                      align="center"
                      className={`${styles.list_table_body}`}
                    >
                      {row.cust_name}
                    </StyledTableCell>
                    <StyledTableCell
                      align="center"
                      className={`${styles.list_table_body}`}
                    >
                      {row.prod_code}
                    </StyledTableCell>
                    <StyledTableCell
                      align="right"
                      className={`${styles.list_table_body}`}
                    >
                      {row.max_holding}
                    </StyledTableCell>
                  </StyledTableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
          <CustomPagination
                              page={controller.page}
                              rowsPerPage={controller.rowsPerPage}
                              totalCount={total_count || 0}
                              onPageChange={(newPage) => handleChangePage(null, newPage)}
                            />
        <DeleteDialog
          open={isDelete}
          handleClose={handleClose}
          deleteInfo={deleteInfo}
          deleteRecord={deleteRecord}
          // deleteID={deleteInfo?.chl.id || null}
          deleteID={deleteInfo?.chl_id || null}
          displayName={deleteInfo?.cust_name || ""}
        />

        <Snackbar
                    anchorOrigin={{ vertical: "top", horizontal: "right" }}
                    open={successMessage ? true : false}
                    autoHideDuration={2000}
                    onClose={(event, reason) => HandleCloseSnackbar(event, reason, setSuccessMessage)}
                    message={successMessage}
                    action={ActionMsg(setSuccessMessage)}
                />
      </Paper>
    </>
  );
};
export default CylHoldingLimitList;
